import React, { useCallback } from 'react';
import { Link } from 'react-router';
import history from '../../../../history';
import LoginBackButton from '../LoginBackButton/LoginBackButton';
import { routeInfo } from './../../../../routeInfo';

export function EmailSentForm() {
    const goBackCb = useCallback(() => {
        history.push(routeInfo.login.url());
    }, []);
    return <div className="email-sent-form">
        <div className="email-sent-form_header">
            <LoginBackButton goBack={goBackCb} />
            Check Your Email
        </div>
        <div className="email-sent-form_msg">
            We’ve sent you an email with a link to verify your account.
            If you don’t receive the email, double check your spam folder.<br /><br />
            Still didn’t receive the email? Contact <a href="mailto:support@alan.app"
                target="_blank" rel="noreferrer">
                support
            </a>.
        </div>
        <Link to={routeInfo.login.path}
            className="email-sent-form_btn">
            OK
        </Link>
    </div>;
}
